export default __webpack_public_path__ + "static/media/Stamp10.3ff6bc14.svg";